import React from "react";
import { IonApp, IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { history, persistor } from "./Store";
import Routes from "./RootRouter";
import { ConnectedRouter as Router } from "connected-react-router";
// import { CodePush, InstallMode, SyncStatus } from "@ionic-native/code-push";
import "./global.scss";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";

import { initializeApp } from "./firebase";
import AppUrlListener from "./AppUrlListener";

initializeApp();

// const stagingIOSKey = "y6upmo5tOQgE7MzDDWPNqdPjeAEY9n5xPRvJ2";
// const prodIOSKey = "Vk04C1CV4ltNiJYVzicf7kowPolxjZozfxI-S";

const App: React.FC = () => (
  <IonApp style={{ maxWidth: 1440, margin: "auto" }}>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <IonReactRouter>
          <AppUrlListener></AppUrlListener>
          <IonRouterOutlet id="main">
            <Router history={history}>
              <Routes />
            </Router>
          </IonRouterOutlet>
        </IonReactRouter>
      </PersistGate>
    </Provider>
  </IonApp>
);

export default App;
